module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "value": _vm.value,
      "transition": "fade-transition",
      "max-width": "1300px",
      "content-class": "ims-standard-dialog"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "ims-modal-card"
  }, [_c('v-toolbar', {
    staticClass: "pairing-elimination-toolbar",
    attrs: {
      "color": "elevation-0"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "pairing-elimination-title"
  }, [_c('h2', {
    staticClass: "headline text-xs-center"
  }, [_vm._v("\n            Please check the columns and influencers list before sending to client.\n          ")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "secondary",
      "aria-label": "Close",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "ims-modal-body"
  }, [_c('v-row', {
    staticClass: "pairing-elimination-options mt-1 mb-2",
    attrs: {
      "justify": "right"
    }
  }, [_c('v-btn-toggle', {
    staticClass: "mr-3",
    attrs: {
      "mandatory": "",
      "color": "secondary"
    },
    on: {
      "change": function($event) {
        return _vm.changeOption()
      }
    },
    model: {
      value: (_vm.optionVal),
      callback: function($$v) {
        _vm.optionVal = $$v
      },
      expression: "optionVal"
    }
  }, [_c('v-btn', {
    staticClass: "option-btn"
  }, [_vm._v("Option A")]), _vm._v(" "), _c('v-btn', {
    staticClass: "option-btn"
  }, [_vm._v("Option B")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('pairing-influencers-table', {
    attrs: {
      "influencers": _vm.pairedInfluencers,
      "elimination": "",
      "internalView": "",
      "campaignID": _vm.campaign.id,
      "campaignData": _vm.campaign
    },
    on: {
      "savedEliminationChanges": _vm.eliminationSubmitted,
      "savedClientNotes": _vm.getPairingList,
      "sendToClient": _vm.invokeSendToClient
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e69c6c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/PairingInfluencer/PairingEliminationEditModal.vue
// module id = 2030
// module chunks = 0